import React from 'react';

import { MissingActionsDialog } from 'src/components/send-for-signature/components/sanity-check-modal/MissingActionsDialog';
import type { ReactSetStateTuple } from 'src/types';

import { UnassignedRolesDialog } from './UnassignedRolesDialog';
import { UnusedActionsDialog } from './UnusedActionsDialog';

export type OpenDialogType = 'missing-actions' | 'unused-actions' | 'unassigned-roles';

interface SendSanityCheckModalProps {
  onClickFixMissingActions: (e: React.MouseEvent) => void;
  onClose: () => void;
  openDialogTuple: ReactSetStateTuple<OpenDialogType | null>;
  workflowId: UUID;
}

export function SanityCheckModal({
  onClickFixMissingActions,
  onClose,
  openDialogTuple: [openDialog],
  workflowId,
}: SendSanityCheckModalProps) {
  return (
    <>
      <MissingActionsDialog
        open={openDialog === 'missing-actions'}
        workflowId={workflowId}
        onClickFixIssue={onClickFixMissingActions}
        onClose={onClose}
      />
      <UnusedActionsDialog
        open={openDialog === 'unused-actions'}
        workflowId={workflowId}
        onClose={onClose}
      />
      <UnassignedRolesDialog
        open={openDialog === 'unassigned-roles'}
        workflowId={workflowId}
        onClose={onClose}
      />
    </>
  );
}
